module.exports = __webpack_public_path__ + "img/+.04809432.svg";